var $ = require('jQuery');

/**
 * Field copier.
 *
 * Usage:
 *   var fieldCopier = new FieldCopier();
 *   fieldCopier.setup(container, from, to);
 *
 */
module.exports = function() {

    /**
     * Maximum length of the copied text
     */
    var maxLength = 32;

    /**
     * Mamory
     */
    var memory = {};

    /**
     * Copy field content on blur
     *
     * @param {String} container
     * @param {String} from
     * @param {String} to
     */
    var copyOnBlur = function(container, from, to) {
        $(container).find(from).each(function(index, field) {
            var fromField = $(field);
            var matches = fromField.attr('name').match(new RegExp("translated\\[" + from.substr(1) + "\\]\\[([^\\]]+)\\]"));
            var language, toField;

            // Skip if cannot extract matches
            if (!$.isArray(matches) || matches.length !== 2) {
                return;
            }

            language = matches[1];

            toField = $(to + '[name="translated[' + to.substr(1) + '][' + language + ']"]');

            fromField.on('blur', function() {
                if (toField.val() !== '' && toField.val() !== memory[language]) {
                    return;
                }

                var value = fromField.val().substring(0, maxLength);

                toField.val(value);

                memory[language] = value;
            });
        });
    };

    /**
     * @param {String} container
     * @param {String} from
     * @param {String} to
     */
    this.setup = function (container, from, to) {
        copyOnBlur(container, from, to);
    };

};
